import styled from "styled-components";

export const StyledOpenedSidebar = styled.div`
  width: ${({ $isOpen }) => ($isOpen ? "240px" : "55px")};
  height: calc(100vh - 88px);
  flex: 0 0 auto;
  background: var(--crypto-bg-deep);
  top: 88px;
  left: 0;
  scroll-padding-top: 9rem;

  position: fixed;
  z-index: 10;
  transform: translateZ(0px);
  overflow: hidden;
  box-shadow: ${({ $isOpen }) =>
    $isOpen ? "16px 0 30px rgba(0, 0, 0, 0.16)" : "none"};
  transition:
    width 320ms cubic-bezier(0.2, 0.8, 0.2, 1),
    box-shadow 320ms ease;

  /* Define the common styles */

  .mobile-sidebar-backdrop {
    display: none;
  }

  .sidebar-open-panel,
  .sidebar-closed-panel {
    position: absolute;
    inset: 0;
    will-change: opacity, transform;
    transition:
      opacity 220ms ease,
      transform 320ms cubic-bezier(0.2, 0.8, 0.2, 1);
  }

  .sidebar-open-panel {
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    transform: ${({ $isOpen }) =>
      $isOpen ? "translateX(0) scale(1)" : "translateX(-16px) scale(0.985)"};
    pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
  }

  .sidebar-closed-panel {
    opacity: ${({ $isOpen }) => ($isOpen ? 0 : 1)};
    transform: ${({ $isOpen }) =>
      $isOpen ? "translateX(-8px) scale(0.96)" : "translateX(0) scale(1)"};
    pointer-events: ${({ $isOpen }) => ($isOpen ? "none" : "auto")};
  }

  .sidebar-content {
    display: flex;
    flex-direction: column;
    padding: 12px 16px 20px;
    height: 100%;
    background: var(--crypto-surface);
    overflow: hidden auto;

    &::-webkit-scrollbar {
      width: 0.6rem;
    }

    &::-webkit-scrollbar-track {
      background: var(--crypto-bg-deep);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: rgba(166, 196, 213, 0.18);
    }
  }

  .closed-sidebar-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: var(--crypto-surface);
    width: 55px;
    padding-top: 0;

    .link {
      position: relative;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: center;
      justify-content: center;
      width: 55px;
      height: 40px;
      cursor: pointer;
      user-select: none;
      transition:
        background 150ms ease,
        color 150ms ease,
        transform 180ms ease;

      &:hover {
        background: rgba(166, 196, 213, 0.07);
        transform: translateX(2px);
      }
    }

    .activated {
      filter: drop-shadow(var(--crypto-green-glow) 0px 0px 6px);
      color: var(--crypto-green);
      text-shadow: var(--crypto-green-glow) 0px 0px 8px;
    }

    svg {
      width: 20px;
      height: 20px;
      color: #b1b6c6;
    }

    svg *:not([fill="none"]) {
      fill: currentColor;
    }

    svg [stroke] {
      stroke: currentColor;
    }
  }

  .other-text {
    color: #686d7b;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14.4px;
    display: flex;
    margin: 14px 0 7px;
  }

  .other-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 9px;
  }

  .sidebar-option-link,
  .sidebar-option-button {
    display: block;
    width: 100%;
    color: inherit;
    text-decoration: none;
  }

  .sidebar-option-button {
    appearance: none;
    border: 0;
    background: transparent;
    padding: 0;
    text-align: left;
    font: inherit;
  }

  .option-sidebar {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    font-size: 14px;
    height: 42px;
    min-height: 42px;
    border-radius: 8px;
    color: #b1b6c6;
    transition: all 0.1s ease 0s;
    padding: 0 6px 0 8px;
    font-weight: 500;
    font-style: normal;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: rgba(166, 196, 213, 0.07);
    }
  }

  .option-disabled {
    opacity: 0.55;
    cursor: default;
    pointer-events: none;
  }

  .option-loading {
    opacity: 0.8;
  }

  .opened-dropdown {
    background: var(--crypto-surface-2) !important;
  }

  .dropdown-options {
    max-height: 0;
    margin: 0;
    padding-left: 8px;
    opacity: 0;
    overflow: hidden;
    transform: translateY(-6px);
    pointer-events: none;
    transition:
      max-height 320ms cubic-bezier(0.2, 0.86, 0.24, 1),
      margin 260ms ease,
      opacity 180ms ease,
      transform 280ms cubic-bezier(0.2, 0.86, 0.24, 1);

    &.is-dropdown-open {
      max-height: 520px;
      margin: 2px 0 7px;
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    &.is-scrollable-dropdown.is-dropdown-open {
      max-height: 224px;
    }

    .dropdown-options-inner {
      display: flex;
      min-height: 0;
      max-height: inherit;
      flex-direction: column;
      gap: 2px;
      overflow: hidden;
    }

    &.is-scrollable-dropdown.is-dropdown-open .dropdown-options-inner {
      overflow: hidden auto;
      padding-right: 4px;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(166, 196, 213, 0.08);
        border-radius: 999px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(89, 244, 119, 0.36);
        border-radius: 999px;
      }
    }

    .option-sidebar {
      height: 36px;
      min-height: 36px;
      border-radius: 7px;
      padding: 0 6px 0 8px;
      font-size: 13px;
      color: #b8becd;
    }

    .icon-img {
      width: 28px;
      min-width: 28px;
      height: 20px;
      margin-right: 3px;

      svg {
        width: 18px !important;
        height: 18px !important;
        max-width: 18px;
        max-height: 18px;
      }
    }

    .info-text {
      font-size: 13px;
      line-height: 15.6px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .option-active {
    background: rgba(166, 196, 213, 0.07);
  }

  .numbers-spacer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .activated {
    filter: drop-shadow(var(--crypto-green-glow) 0px 0px 6px);
    color: var(--crypto-green) !important;
  }

  .icon-img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    min-width: 34px;
    height: 24px;
    margin-right: 4px;
    color: #b1b6c6;

    svg {
      display: block;
      width: 22px !important;
      height: 22px !important;
      max-width: 22px;
      max-height: 22px;
      color: currentColor;
    }

    svg *:not([fill="none"]) {
      fill: currentColor;
    }

    svg [stroke] {
      stroke: currentColor;
    }
  }

  .icon-arrow {
    width: 30px;
    height: 30px;
  }

  .info-text {
    width: 100%;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16.8px;
  }

  .info-number {
    width: 46px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16.8px;
  }

  .count {
    width: 14px;
    color: #b1b6c6;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 13.2px;
  }

  .divider {
    min-height: 25px;
    margin-top: auto;
  }

  .payment {
    padding: 25px 20px;
    margin: 0px -16px -20px;
    background: rgba(166, 196, 213, 0.07);

    .payment-methods {
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      justify-content: space-between;
      margin-top: 20px;
      margin-left: -2px;
    }

    .buy-crypto {
      width: 100%;
      letter-spacing: 0.5px;
      padding: 0px 20px;

      color: rgb(255, 255, 255);
      background: rgba(166, 196, 213, 0.13);
    }
  }

  @media (max-width: 1023px) {
    width: 100vw;
    height: 100dvh;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 89;
    background: transparent;
    box-shadow: none;
    overflow: visible;
    pointer-events: none;
    transition: none;

    .mobile-sidebar-backdrop {
      appearance: none;
      display: block;
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      border: 0;
      border-radius: 0;
      background: rgba(1, 9, 12, 0.58);
      box-shadow: none;
      outline: none;
      opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
      pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
      transition: opacity 240ms ease;
      -webkit-tap-highlight-color: transparent;
    }

    .sidebar-closed-panel {
      display: none;
    }

    .sidebar-open-panel {
      position: fixed;
      top: auto;
      right: 0;
      bottom: calc(66px + env(safe-area-inset-bottom));
      left: 0;
      height: auto;
      padding: 0 12px;
      opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
      transform: ${({ $isOpen }) =>
        $isOpen ? "translateY(0) scale(1)" : "translateY(22px) scale(0.985)"};
      pointer-events: ${({ $isOpen }) => ($isOpen ? "auto" : "none")};
      transition:
        opacity 210ms ease,
        transform 280ms cubic-bezier(0.2, 0.86, 0.24, 1);
    }

    .sidebar-content {
      width: min(100%, 520px);
      height: min(72dvh, 640px);
      margin: 0 auto;
      padding: 16px 18px calc(18px + env(safe-area-inset-bottom));
      border: 1px solid rgba(177, 205, 224, 0.14);
      border-bottom: 0;
      border-radius: 22px 22px 0 0;
      background: #0b2028;
      box-shadow: 0 -20px 50px rgba(0, 0, 0, 0.36);
      overflow: hidden auto;
    }

    .w-38 {
      width: auto;
    }

    .other-text {
      margin-top: 10px;
      margin-bottom: 8px;
      font-size: 12px;
      color: #8493a3;
    }

    .other-section {
      gap: 5px;
      margin-bottom: 12px;
    }

    .option-sidebar {
      height: 44px;
      min-height: 44px;
      border-radius: 10px;
      padding-inline: 10px 8px;
      background: transparent;
    }

    .opened-dropdown,
    .option-active {
      background: rgba(166, 196, 213, 0.08) !important;
    }

    .dropdown-options {
      margin-left: 4px;
      padding-left: 6px;

      &.is-dropdown-open {
        margin: 4px 0 8px 4px;
      }
    }
  }

  @media (max-width: 420px) {
    .sidebar-open-panel {
      padding: 0 8px;
    }

    .sidebar-content {
      height: min(76dvh, 620px);
      border-radius: 20px 20px 0 0;
      padding-inline: 14px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    &,
    .sidebar-open-panel,
    .sidebar-closed-panel,
    .mobile-sidebar-backdrop,
    .dropdown-options {
      transition: none;
    }
  }
`;

export const StyledClosedSidebar = styled.div`
  height: calc(100vh - 88px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--crypto-surface);
  width: 55px;
  position: fixed;
  top: 88px;
  z-index: 10;

  .link {
    position: relative;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 55px;
    height: 40px;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: rgba(166, 196, 213, 0.07);
    }
  }

  .activated {
    filter: drop-shadow(var(--crypto-green-glow) 0px 0px 6px);
    color: var(--crypto-green);
    text-shadow: var(--crypto-green-glow) 0px 0px 8px;
  }

  svg {
    width: 20px;
    height: 20px;
    color: #b1b6c6;
  }

  svg *:not([fill="none"]) {
    fill: currentColor;
  }

  svg [stroke] {
    stroke: currentColor;
  }
`;
